import { render, staticRenderFns } from "./PayRunApproval.vue?vue&type=template&id=6f390012&scoped=true"
import script from "./PayRunApproval.vue?vue&type=script&lang=js"
export * from "./PayRunApproval.vue?vue&type=script&lang=js"
import style0 from "./PayRunApproval.vue?vue&type=style&index=0&id=6f390012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f390012",
  null
  
)

export default component.exports